import { HiArrowUpRight } from "react-icons/hi2";

export const Unauthorized = () => {
  return (
    <div className="min-h-screen flex flex-grow items-center justify-center bg-[#F5F5F5]">
      <div className="rounded-[12px] bg-white border border-[#E0E0E0] p-8 text-center shadow-[0_4px_16px_rgba(0,0,0,0.06)] max-w-md">
        <h1 className="mb-4 text-4xl font-bold text-[#1A1A1A]">401</h1>
        <p className="text-[#666666] mb-6">
          The request has not been applied because it lacks valid
          authentication credentials for the target resource.
        </p>
        <a
          href="/login"
          className="inline-flex items-center gap-2 rounded-lg bg-[#2A7FA5] hover:bg-[#226687] px-5 py-2.5 text-sm font-semibold uppercase text-white transition-colors no-underline"
        >
          Go back to login <HiArrowUpRight size={14} />
        </a>
      </div>
    </div>
  );
};
